module.exports = __webpack_public_path__ + "static/media/about-20.f5b180eb.webp";